export const COOKIE_CONSENT_COOKIE = "gatsby-google-analytics-consent";
const COOKIE_MAX_AGE_DAYS = 180;

export type CookieConsentState = "accepted" | "rejected" | "unset";

const parseCookieValue = (value?: string): CookieConsentState => {
  if (value === "true") {
    return "accepted";
  }

  if (value === "false") {
    return "rejected";
  }

  return "unset";
};

export const getCookieConsentState = (): CookieConsentState => {
  if (typeof document === "undefined") {
    return "unset";
  }

  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${COOKIE_CONSENT_COOKIE}=`));

  if (!cookie) {
    return "unset";
  }

  return parseCookieValue(cookie.split("=")[1]);
};

export const hasAnalyticsConsent = (): boolean =>
  getCookieConsentState() === "accepted";

const buildCookieAttributes = (): string[] => {
  const attributes = [
    "Path=/",
    `Max-Age=${COOKIE_MAX_AGE_DAYS * 24 * 60 * 60}`,
    "SameSite=Lax",
  ];

  if (
    typeof window !== "undefined" &&
    window.location.protocol === "https:"
  ) {
    attributes.push("Secure");
  }

  return attributes;
};

export const setCookieConsentState = (state: Exclude<CookieConsentState, "unset">) => {
  if (typeof document === "undefined") return;

  const value = state === "accepted" ? "true" : "false";
  document.cookie = `${COOKIE_CONSENT_COOKIE}=${value}; ${buildCookieAttributes().join("; ")}`;
};

export const resetCookieConsentState = () => {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${COOKIE_CONSENT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
};
